module.exports = "/_next/static/images/favicon-5a1a200a9bd64f26a23271d741e9a23d.png";